export var VIDEO_CARD_TYPES;
(function (VIDEO_CARD_TYPES) {
    VIDEO_CARD_TYPES["CHANNEL"] = "channel";
    VIDEO_CARD_TYPES["VIDEO"] = "video";
    VIDEO_CARD_TYPES["RECENT_VIDEO"] = "recent-video";
    VIDEO_CARD_TYPES["PRODUCT"] = "product";
    VIDEO_CARD_TYPES["SOCIAL"] = "social";
    VIDEO_CARD_TYPES["CUSTOM"] = "custom";
})(VIDEO_CARD_TYPES || (VIDEO_CARD_TYPES = {}));
//# sourceMappingURL=types.js.map